import React from 'react';


const Home = () => {


    return (
        <div className='home-page'>
            <h3>Welcome to BC SportsLive!</h3>
            <p>Home to all sports scores and updates.</p>
            <p>Check in on your favorite leagues and teams to get the latest scores.</p>
        </div>
    )
}

export default Home;